/* eslint-disable object-curly-spacing */ 
/* eslint-disable no-undef */ 
/* eslint-disable own-handles */ 
/* eslint-disable no-innerhtml-assign */ 
/* eslint-disable consistent-method-names */ 
/* eslint-disable no-jsdoc */ 
/**
 * This widget allows the user to do distance measurements on the map.
 *
 * @example
 * ###### Basic example
 *
 * ```javascript
 * var map = new L.Map('map', {
 *   key: "your-key",
 *   center: [52.373154, 4.890659],
 *   zoom: 13
 * });
 * var widget = new L.DistanceMeasurement();
 * widget.addTo(map);
 * ```
 *
 * ###### Using options
 *
 * ```javascript
 * var map = new L.Map('map', {
 *   key: "your-api-key",
 *   center: [52.373154, 4.890659],
 *   zoom: 13
 * });
 * var widget = new L.DistanceMeasurement({
 *   unitScheme: 'imperial',
 *   markerColor: '#99ff99'
 * });
 * map.addControl(widget);
 * ```
 *
 * @class DistanceMeasurement
 * @namespace L
 * @extends L.Control
 * @uses L.Evented
 * @module Widgets
 * @constructor
 * @param {Object} [options]
 * @param {"topleft"|"topright"|"bottomleft"|"bottomright"} [options.position="topright"] Decides the location
 *     of the widget
 * @param {String} [options.markerColor="#000"] Color of the markers used for each step of the ruler
 * @param {String} [options.lineColor="#000"] Color or the ruler's line
 * @param {"metric"|"imperial"|null} [options.unitScheme=null] Indicate if the imperial measurement unit should
 *     be used for calculate the distances.
 *     If the value is null the widget will use the global unit measurement configuration.
 * @param {Boolean} [options.useArc=false] Display great circle arcs instead of rect lines
 */
/* jshint nomen:false */
define(['display/map', './measurementRuler', './multiMeasurementRuler', 'services/utils'],
    function(L, MeasurementRuler, MultiMeasurementRuler, Utils) {
        'use strict';

        L.DistanceMeasurement = L.Control.extend({
            includes: L.Evented.prototype,

            options: {
                position: 'topright',
                markerColor: '#000',
                lineColor: '#000',
                unitScheme: null,
                useArc: false
            },

            statics: {
                Events: {
                    /**
                     * Fired when the user press over the button to activate the widget.
                     * After the first click over the map the measurement rule and the distance counter will appear.
                     * @event Activated
                     * @type String
                     *
                     * @example
                     * ```javascript
                     *
                     * var widget = (new L.DistanceMeasurement()).addTo(map);
                     * widget.on(L.DistanceMeasurement.Events.Activated, function (eventObject) {
                     *      console.log(eventObject);
                     * });
                     * ```
                     */
                    Activated: 'active',
                    /**
                     * Fired when the user press over the widget's button when is already activated disabling the
                     * widget and hiding the measurement controls.
                     * @event Deactivated
                     * @type String
                     */
                    Deactivated: 'inactive',
                    /**
                     * Fired when a new measurement starts.
                     * The measurement starts when the user make the first click on the map.
                     * @event Started
                     * @type String
                     */
                    Started: 'start',
                    /**
                     * Fired when the ruler path changes (by adding more segments).
                     * @event L.DistanceMeasurement.Events.Changed
                     * @param {L.MeasurementRuler} ruler Reference to the ruler instance
                     * @param {L.LatLng} newSegment The coordinates of the last new segment added
                     * @param {Number} distance Total ruler distance in meters after adding the new segment
                     */
                    Changed: 'change',
                    /**
                     * Fired when the user finish an active measurement.
                     * @event L.DistanceMeasurement.Events.Finished
                     * @param {L.MeasurementRuler} ruler Reference to the ruler instance
                     * @param {Number} distance Total ruler distance in meters
                     */
                    Finished: 'finish',
                    /**
                     * Fired when the user decide to cancel an active measurement.
                     * @event Cancelled
                     * @type String
                     */
                    Cancelled: 'cancel',
                    /**
                     * Fired when all the measurements are cleared from the screen.
                     * @event Reset
                     * @type String
                     */
                    Reset: 'reset',
                    /**
                     * Fired when the widget is disabled using the
                     * {{#crossLink "L.DistanceMeasurement/disable:method"}}{{/crossLink}} method.
                     * @event Disabled
                     * @type String
                     */
                    Disabled: 'disable',
                    /**
                     * Fired when the widget is enabled (after had been disabled) using the
                     * {{#crossLink "L.DistanceMeasurement/enable:method"}}{{/crossLink}} method.
                     * @event Enabled
                     * @type String
                     */
                    Enabled: 'enable'
                }
            },

            /**
             * @ignore
             * CSS class names used by the elements of this widget.
             * @type {Object}
             */
            _classnames: {
                // Class added to the map container when the widget is activated
                mapContainer: 'leaflet-with-distance-measurement',

                // Container of the widget
                container: 'leaflet-bar leaflet-distance-measurement',
                // CSS classes added to the widget container during its lifecycle
                containerActive: 'leaflet-distance-measurement--active',
                containerInProgress: 'leaflet-distance-measurement--in-progress',

                // Widget's main button
                onoffButton: 'leaflet-distance-measurement__onoff-button icon-ruler',
                onoffButtonEnabled: 'leaflet-distance-measurement__onoff-button--enabled',
                onoffButtonDisabled: 'leaflet-disabled',

                // Container of the widget actions buttons
                actionsButtons: 'leaflet-distance-measurement__actions',
                actionsButtonsVisible: 'leaflet-distance-measurement__actions--visible',

                // Action buttons
                finishButton: 'leaflet-distance-measurement__actions__finish',
                cancelButton: 'leaflet-distance-measurement__actions__cancel',

                // Class names used for the rulers and ruler labels
                markerLabel: 'leaflet-distance-measurement__ruler__label',
                previewMarkerLabel: 'leaflet-distance-measurement__ruler__label-preview',
                ruler: 'leaflet-distance-measurement__ruler',
                previewRuler: 'leaflet-distance-measurement__ruler-preview'
            },

            /**
             * @ignore
             * Leaflet layer where all the magic happen.
             * @type {L.FeatureGroup}
             */
            _layer: null,

            /**
             * @ignore
             * Object with references to the DOM elements of the widget.
             * @type {Object}
             */
            _controls: null,

            /**
             * @ignore
             * Reference to the leaflet map instance.
             * @type {L.Map}
             */
            _map: null,

            /**
             * @ignore
             * This value is TRUE if the widget has been disabled using the disable() method.
             * @type {Boolean}
             */
            _disabled: false,

            /**
             * @ignore
             * This value is TRUE if the measurement controls are visible.
             * @type {Boolean}
             */
            _isActivated: false,

            /**
             * @ignore
             * This value is TRUE if a measurement is in progress.
             * @type {Boolean}
             */
            _isMeasurementInProgress: false,

            /**
             * @ignore
             * Store the status of conflictive map features to be reactivated when this widget is deactivated.
             * @type {Object}
             */
            _previousStatusOfConflictiveFeatures: null,

            /**
             * @ignore
             * Current measurement instance.
             * @type {L.MultiMeasurementRuler}
             */
            _activeRulerLayer: null,

            /**
             * @ignore
             * Ruler used during a measurement in progress to display a preview segment when the cursor
             * moves over the map.
             * @type {L.MeasurementRuler}
             */
            _previewRulerSegment: null,

            /**
             * @ignore
             * Stack of previous measurements.
             * Each time a measurement is finished, the finished ruler is added to this array.
             * @type {L.MultiMeasurementRuler[]}
             */
            _rulerLayerStack: [],

            /**
             * @ignore
             * @type String[]
             */
            _supportedUnits: [],

            /**
             * The unit service used by the widget to display the distances.
             * @ignore
             * @type UnitService
             */
            _unitService: null,

            /**
             * Curated snapshot of the widget's options created at the beginning of each measurement and using it during
             * its lifecycle.
             * This options are used for the active and preview rulers until the measurement finish.
             * That increases stability if the widget's options changes during a measurement.
             * @ignore
             * @type Object
             */
            _activeOptions: null,

            initialize: function(options) {
                L.Util.setOptions(this, options);
                this._rulerLayerStack = [];
                this._activeRulerLayer = null;
                this._previewRulerSegment = null;
                this._isMeasurementInProgress = false;
                this._isActivated = false;
                this._disabled = false;
                this._supportedUnits = L.UnitService.getSupportedUnits().map(function(unit) {
                    return unit.getLabel();
                });
                // Copying static Events property to instance Events property for compatibility
                this.Events = L.DistanceMeasurement.Events;
            },

            /**
             * @ignore
             * Create the DOM elements needed and returns an object with them.
             * @return {Object}
             */
            _createControls: function() {
                var container = L.DomUtil.create('div', this._classnames.container),
                    onoffButton = L.DomUtil.create('a', this._classnames.onoffButton, container),
                    actionsButtons = L.DomUtil.create('ul', this._classnames.actionsButtons, container),
                    finishButton = L.DomUtil.create('li', this._classnames.finishButton, actionsButtons),
                    cancelButton = L.DomUtil.create('li', this._classnames.cancelButton, actionsButtons);

                // Icons
                finishButton.innerHTML = '&#10003;';
                cancelButton.innerHTML = '&times;';

                onoffButton.href = '#';

                // Labels
                onoffButton.title = 'Toggle measurement tool';
                finishButton.title = 'Finish measurement';
                cancelButton.title = 'Cancel measurement';

                // For screen readers
                onoffButton.setAttribute('role', 'button');
                onoffButton.setAttribute('aria-label', onoffButton.title);
                finishButton.setAttribute('role', 'button');
                finishButton.setAttribute('aria-label', finishButton.title);
                cancelButton.setAttribute('role', 'button');
                cancelButton.setAttribute('aria-label', cancelButton.title);

                return {
                    container: container,
                    actionsButtons: actionsButtons,
                    finishButton: finishButton,
                    cancelButton: cancelButton,
                    onoffButton: onoffButton
                };
            },

            _attachDomEventHandlersToControls: function() {
                L.DomEvent.disableClickPropagation(this._controls.container);
                L.DomEvent.disableScrollPropagation(this._controls.container);

                L.DomEvent
                    .on(this._controls.onoffButton, 'click', L.DomEvent.stop)
                    .on(this._controls.onoffButton, 'click', this.toggleActivation, this);
                L.DomEvent
                    .on(this._controls.finishButton, 'click', L.DomEvent.stop)
                    .on(this._controls.finishButton, 'click', this._finishMeasurement, this);
                L.DomEvent
                    .on(this._controls.cancelButton, 'click', L.DomEvent.stop)
                    .on(this._controls.cancelButton, 'click', this._cancelOrResetMeasurement, this);
            },

            /**
             * @ignore
             * Attach a click event listener to the given layer.
             * @param {L.Layer|Event} layerOrEvent
             */
            _layerClickListenerOn: function(layerOrEvent) {
                var layer = layerOrEvent.hasOwnProperty('layer') ? layerOrEvent.layer : layerOrEvent;
                layer.on('click', this._mouseClickHandler, this);
            },

            /**
             * @ignore
             * Detach the click event listener from the given layer.
             * @param {L.Layer} layer
             */
            _layerClickListenerOff: function(layer) {
                layer.off('click', this._mouseClickHandler, this);
            },

            /**
             * @ignore
             * Install click listeners on map and all its existing layers.
             */
            _startListenClicks: function() {
                this._map.eachLayer(this._layerClickListenerOn, this);
                this._map.on('click', this._mouseClickHandler, this);
                this._map.on('layeradd', this._layerClickListenerOn, this);
            },

            /**
             * @ignore
             * Remove all the click listeners from map and its existing layers.
             */
            _stopListenClicks: function() {
                this._map.eachLayer(this._layerClickListenerOff, this);
                this._map.off('click', this._mouseClickHandler, this);
                this._map.off('layeradd', this._layerClickListenerOn, this);
            },

            /**
             * @ignore
             * Reference: https://leafletjs.com/reference-1.0.3.html#control-onadd
             * @param {L.Map} map
             * @return {HTMLElement} The control's container
             */
            onAdd: function(map) {
                this._unitService = map.getUnitService();
                this._unitService.on(L.UnitService.Events.UNIT_CHANGED, this._onMapMeasurementUnitChanged, this);
                this._controls = this._createControls();
                this._attachDomEventHandlersToControls();
                return this._controls.container;
            },

            /**
             * @ignore
             * Reference: https://leafletjs.com/reference-1.0.3.html#layer-onremove
             */
            onRemove: function() {
                this._unitService.off(L.UnitService.Events.UNIT_CHANGED, this._onMapMeasurementUnitChanged, this);
                this.deactivate();
            },

            /**
             * @ignore
             * This method is here to redraw the rulers only if the widget doesn't have a valid string in the
             * `unitScheme` option.
             */
            _onMapMeasurementUnitChanged: function() {
                if (this._activeOptions && this._activeOptions.unitScheme === null) {
                    this.redrawRulers();
                }
            },

            /**
             * Destroy and create again all the visible rulers with the current widget options.
             *
             * Useful when the options are changed and you need to apply them to all the previous measurements.
             *
             * @method redrawRulers
             */
            redrawRulers: function() {
                var that = this, activeLatLngs, lastPreviewLatLng;
                // Recreating active ruler
                if (this._activeRulerLayer) {
                    activeLatLngs = this._activeRulerLayer.latLngs.slice(0);
                    this._activeRulerLayer.remove();
                    this._activeRulerLayer = null;
                    this._startActiveRuler();
                    this._activeRulerLayer.setLatLngs(activeLatLngs);
                }
                // Recreating preview ruler
                if (this._previewRulerSegment) {
                    lastPreviewLatLng = this._previewRulerSegment.getLast();
                    this._previewRulerSegment.remove();
                    this._previewRulerSegment = null;
                    this._redrawRulerPreviewSegment(lastPreviewLatLng);
                }
                // Recreating stacked rulers
                this._rulerLayerStack = this._rulerLayerStack.map(function(ruler) {
                    var latLngs = ruler.latLngs.slice(0);
                    var newRuler = that._createRuler();
                    ruler.remove();
                    newRuler.setLatLngs(latLngs);
                    return newRuler.addTo(that._map);
                });
            },
            /**
             * @ignore
             * Creates a curated copy of the widget's options.
             * This copy is used across the measurement lifecycle.
             */
            _rebuildCuratedOptionsSnapshot: function() {
                this._activeOptions = L.Util.extend({}, this.options);

                if (Utils.isValidValue(this._activeOptions.unitScheme)) {
                    if (this._supportedUnits.indexOf(this._activeOptions.unitScheme) === -1) {
                        this._activeOptions.unitScheme = null;
                        console.warn('The unit scheme given to distanceMeasurement widget is not valid');
                    }
                }
            },
            /**
             * Returns the measurement unit that should be used priorizing the configuration given to this widget.
             *
             * This method doesn't validate the value of the option `unitScheme`.
             * @ignore
             * @return {String}
             */
            _getUnitScheme: function() {
                return this._activeOptions.unitScheme || this._unitService.getCurrentUnit().getLabel();
            },

            /**
             * Creates the leaflet layer where the ruler, markers and distance labels will use.
             * @ignore
             */
            _addDrawingLayer: function() {
                this._removeDrawingLayer();
                this._layer = L.featureGroup()
                    .addTo(this._map);
            },

            _removeDrawingLayer: function() {
                if (this._layer) {
                    this._layer.removeFrom(this._map);
                    this._layer = null;
                }
            },

            /**
             * Activate the widget displaying the measurement controls and wait for the user to click over
             * the map to start the first measurement.
             *
             * This method is called automatically when the user press over the widget's main button.
             *
             * @method activate
             */
            activate: function() {
                var mapContainer = this._map.getContainer();

                if (this._disabled || this._isActivated) {
                    return;
                }

                this._isActivated = true;

                L.DomUtil.addClass(mapContainer, this._classnames.mapContainer);
                L.DomUtil.addClass(this._controls.actionsButtons, this._classnames.actionsButtonsVisible);

                L.DomUtil.addClass(this._controls.container, this._classnames.containerActive);

                L.DomUtil.addClass(this._controls.onoffButton, this._classnames.onoffButtonEnabled);

                this._addDrawingLayer();

                this._disableConflictiveMapFeatures();

                this._startListenClicks();

                this.fire(L.DistanceMeasurement.Events.Activated);
            },

            /**
             * Deactivate the widget cleaning all the rulers over the map and hiding the measurement controls.
             *
             * If a measurement was in progress, it will be cancel first.
             *
             * @method deactivate
             */
            deactivate: function() {
                var mapContainer = this._map.getContainer();

                if (!this._isActivated) {
                    return;
                }

                if (this._isMeasurementInProgress) {
                    this._cancelMeasurement();
                }

                this._resetMeasurement();

                this._isActivated = false;

                L.DomUtil.removeClass(mapContainer, this._classnames.mapContainer);
                L.DomUtil.removeClass(this._controls.actionsButtons, this._classnames.actionsButtonsVisible);

                L.DomUtil.removeClass(this._controls.container, this._classnames.containerActive);

                L.DomUtil.removeClass(this._controls.onoffButton, this._classnames.onoffButtonEnabled);

                this._stopListenClicks();

                this._removeDrawingLayer();

                this._restoreConflictiveMapFeatures();

                this.fire(L.DistanceMeasurement.Events.Deactivated);

                // Re-focusing the map to restore keyboard navigation
                this._map.getContainer().focus();
            },

            /**
             * Activate or deactivate the widget depending of its current state.
             * @method toggleActivation
             * @chainable
             * @return {L.DistanceMeasurement}
             */
            toggleActivation: function() {
                if (this._isActivated) {
                    this.deactivate();
                } else {
                    this.activate();
                }
                return this;
            },

            /**
             * @ignore
             * Store the current active conflict map features status internally to be reactivate later when the widget
             * is deactivated.
             */
            _storeCurrentStatusOfConflictiveMapFeatures: function() {
                this._previousStatusOfConflictiveFeatures = {
                    doubleClickZoom: this._map.doubleClickZoom.enabled(),
                    boxZoom: this._map.boxZoom.enabled(),
                    keyboard: this._map.keyboard.enabled()
                };
            },

            /**
             * @ignore
             * Some map features are disabled during the measurement to avoid conflicts with this widget.
             * Those features should be reactivated when the widget is deactivated.
             */
            _disableConflictiveMapFeatures: function() {
                this._storeCurrentStatusOfConflictiveMapFeatures();
                this._map.doubleClickZoom.disable();
                this._map.boxZoom.disable();
                this._map.keyboard.disable();
            },

            /**
            * @ignore
            * Restore the map conflict features disabled by _disableConflictiveMapFeatures().
            * Only the features enabled before the activation of this widget will be reactivated.
            */
            _restoreConflictiveMapFeatures: function() {
                if (this._previousStatusOfConflictiveFeatures !== null) {
                    if (this._previousStatusOfConflictiveFeatures.doubleClickZoom) {
                        this._map.doubleClickZoom.enable();
                    }

                    if (this._previousStatusOfConflictiveFeatures.boxZoom) {
                        this._map.boxZoom.enable();
                    }

                    if (this._previousStatusOfConflictiveFeatures.keyboard) {
                        this._map.keyboard.enable();
                    }
                    this._previousStatusOfConflictiveFeatures = null;
                }
            },

            /**
             * @ignore
             * Checks if two coordinates points to the same location.
             * @param {L.LatLng} firstLatLon
             * @param {L.LatLng} secondLatLon
             * @return {Boolean}
             */
            _equalLatLng: function(firstLatLon, secondLatLon) {
                if (firstLatLon === secondLatLon) {
                    return true;
                }
                if (firstLatLon && secondLatLon) {
                    return firstLatLon.equals(secondLatLon);
                }
                return false;
            },

            /**
             * @ignore
             * Function called when the user does a click over the map while the widget is active.
             * @param {MouseEvent} event
             */
            _mouseClickHandler: function(event) {
                var latLng = event.latlng;

                if (latLng === undefined) {
                    return;
                }

                if (!this._isMeasurementInProgress) {
                    this._startMeasurement(latLng);
                    this._activeRulerLayer.addLatLng(latLng);

                } else {
                    if (this._equalLatLng(this._activeRulerLayer.getLast(), latLng)) {
                        return;
                    }

                    latLng = this._translateLatLngToAchieveClosestPath(latLng);

                    this._redrawRulerPreviewSegment();
                    this._activeRulerLayer.addLatLng(latLng);
                    this._onChangeMeasurement(latLng);
                }
            },

            /**
             * Translate the coordinates horizontally if necessary to put them closer to the end of the current active
             * ruler.
             *
             * The active Ruler is an instance of MultiMeasurementRule which drawn several identical polylines at 360
             * longitude degrees of separation to show the same Ruler multiple times when one coordinate appears more
             * than once on the screen.
             *
             * Leaflet is not limited to 360 longitude degrees and it keeps increasing or decreasing the degrees until
             * is able to reutilize a "world copy" (the property "worldCopyJump" is set to true by default in this SDK
             * to accomplish that).
             * This means that, in the same map, the coordinates <0,10>, <-0,-350> and <0,370> all represent the exact
             * same place in the world but drawing a line between <0,10> and <0,11> will be very different to the line
             * between <0,10> and <0,371>.
             *
             * To avoid having very long polylines crossing the world, this method adds or subtracts 360 longitude
             * degrees to the given coordinates to put it closer (in pixels) to the last point of one of the active
             * ruler's polylines.
             *
             * @ignore
             * @param {L.LatLng} latLng
             * @return {L.LatLng}
             */
            _translateLatLngToAchieveClosestPath: function(latLng) {
                var lastLatLng = this._activeRulerLayer.getLast(),
                    closestLastLatLng = this._activeRulerLayer.getClosestLast(latLng),
                    transOffsetDegrees = 360,
                    times;

                if (Math.round(closestLastLatLng.lng) < Math.round(lastLatLng.lng)) {
                    times = Math.ceil((lastLatLng.lng - closestLastLatLng.lng) / transOffsetDegrees);
                    return L.latLng(latLng.lat, latLng.lng + (transOffsetDegrees * times));

                } else if (Math.round(closestLastLatLng.lng) > Math.round(lastLatLng.lng)) {
                    times = Math.ceil((closestLastLatLng.lng - lastLatLng.lng) / transOffsetDegrees);
                    return L.latLng(latLng.lat, latLng.lng - (transOffsetDegrees * times));
                }

                return latLng;
            },

            /**
             * @ignore
             * Update the temporal ruler segment line over the map.
             *
             * Calls to this function will be ignored if:
             *  - There's no active ruler on the screen (distance zero).
             *  - The coordinates given are undefined.
             *  - The coordinates given are the same as the last coordinates of the ruler.
             *
             * @param {L.LatLng} [previewLatLng=undefined] End coordinates of the possible new segment. The start
             * coordinates will be taken from the active ruler coordinates.
             */
            _redrawRulerPreviewSegment: function(previewLatLng) {
                var lastLatLng,
                    rulerOptions = {
                        rulerClassname: [this._classnames.ruler, this._classnames.previewRuler].join(' '),
                        labelClassname: [this._classnames.markerLabel, this._classnames.previewMarkerLabel].join(' '),
                        markerColor: this._activeOptions.markerColor,
                        lineColor: this._activeOptions.lineColor,
                        distanceOffset: this._activeRulerLayer.distance,
                        unitScheme: this._getUnitScheme(),
                        useArc: this._activeOptions.useArc
                    };

                if (previewLatLng) {
                    lastLatLng = this._activeRulerLayer.getClosestLast(previewLatLng);
                }

                if (lastLatLng && previewLatLng && !this._equalLatLng(lastLatLng, previewLatLng)) {
                    if (!this._previewRulerSegment) {
                        this._previewRulerSegment = new MeasurementRuler(rulerOptions)
                            .addTo(this._layer);
                    }
                    this._previewRulerSegment.setLatLngs([lastLatLng, previewLatLng]);

                } else if (this._previewRulerSegment) {
                    this._previewRulerSegment.remove();
                    this._previewRulerSegment = null;
                }
            },

            /**
             * @ignore
             * Function called each time the cursor moves over the map.
             * @param {MouseEvent} event
             */
            _mouseMoveHandler: function(event) {
                this._redrawRulerPreviewSegment(event.latlng);
            },

            /**
             * @ignore
             * Creates a new ruler instance base it the widget options.
             * @param {L.LatLng} latLng
             * @return {L.MeasurementRuler}
             */
            _createRuler: function() {
                var rulerOptions = {
                    rulerClassname: this._classnames.ruler,
                    labelClassname: this._classnames.markerLabel,
                    markerColor: this._activeOptions.markerColor,
                    lineColor: this._activeOptions.lineColor,
                    unitScheme: this._getUnitScheme(),
                    useArc: this._activeOptions.useArc
                };
                return new MultiMeasurementRuler(rulerOptions);
            },

            /**
             * Creates a new ruler and add it to the current map as an active ruler.
             * @ignore
             * @return {L.MeasurementRuler}
             */
            _startActiveRuler: function() {
                if (this._activeRulerLayer) {
                    throw new Error('An active ruler already exist');
                }
                this._activeRulerLayer = this._createRuler().addTo(this._layer);
                return this._activeRulerLayer;
            },

            /**
             * Executed when the user does the first click over the map.
             * @ignore
             * @param {L.LatLng} latLng
             */
            _startMeasurement: function(latLng) {
                this._rebuildCuratedOptionsSnapshot();

                this._startActiveRuler();

                this._isMeasurementInProgress = true;

                L.DomUtil.addClass(this._controls.container, this._classnames.containerInProgress);

                this.fire(L.DistanceMeasurement.Events.Started, latLng);

                this._map.on('mousemove', this._mouseMoveHandler, this);
                this._map.on('dblclick', this._finishMeasurement, this);
            },

            /**
             * @ignore
             * Executed when a new ruler segment is added to the path.
             * @param {L.LatLng} latLng New ruler segment end coordinates
             */
            _onChangeMeasurement: function(latLng) {
                this.fire(L.DistanceMeasurement.Events.Changed, {
                    ruler: this._activeRulerLayer,
                    newSegment: latLng,
                    distance: this._activeRulerLayer.distance
                });
            },

            _stopMeasurement: function() {
                this._isMeasurementInProgress = false;

                L.DomUtil.removeClass(this._controls.container, this._classnames.containerInProgress);

                this._map.off('mousemove', this._mouseMoveHandler, this);
                this._map.off('dblclick', this._finishMeasurement, this);

                this._redrawRulerPreviewSegment();
            },

            /**
             * @ignore
             * Restart the measurement clearing also the ruler, markers and labels from
             * the map.
             */
            _resetMeasurement: function() {
                if (this._activeRulerLayer || this._rulerLayerStack.length > 0) {
                    if (this._activeRulerLayer) {
                        this._cancelMeasurement();
                    }
                    if (this._rulerLayerStack.length > 0) {
                        this._rulerLayerStack.forEach(function(ruler) {
                            ruler.remove();
                        });
                        this._rulerLayerStack = [];
                    }
                    this.fire(L.DistanceMeasurement.Events.Reset);
                }
            },

            _moveActiveRulerToStack: function() {
                this._rulerLayerStack.push(this._activeRulerLayer);
                this._activeRulerLayer = null;
            },

            /**
             * @ignore
             * Called when the user finish the measurement.
             */
            _finishMeasurement: function() {
                if (!this._isMeasurementInProgress) {
                    return;
                }

                if (this._activeRulerLayer.distance === 0) {
                    // If the ruler is empty, the measurement is considered INVALID
                    this._cancelMeasurement();

                } else {
                    this._stopMeasurement();
                    this.fire(L.DistanceMeasurement.Events.Finished, {
                        ruler: this._activeRulerLayer,
                        distance: this._activeRulerLayer.distance
                    });
                    this._moveActiveRulerToStack();
                }
            },

            /**
             * @ignore
             * Called when the user decide to cancel a measurement in progress.
             */
            _cancelMeasurement: function() {
                if (this._isMeasurementInProgress) {
                    this._stopMeasurement();
                    this._activeRulerLayer.remove();
                    this._activeRulerLayer = null;
                    this.fire(L.DistanceMeasurement.Events.Cancelled);
                }
            },

            /**
             * @ignore
             * Called when the user decide to cancel a measurement in progress or reset the
             * current finished measurement.
             */
            _cancelOrResetMeasurement: function() {
                if (this._isMeasurementInProgress) {
                    this._cancelMeasurement();
                } else {
                    this._resetMeasurement();
                }
            },

            /**
             * Disables the widget's instance to not allowing user interaction.
             * @method disable
             * @chainable
             * @return {L.DistanceMeasurement}
             */
            disable: function() {
                if (!this._disabled) {
                    this.deactivate();
                    this._disabled = true;
                    L.DomUtil.addClass(this._controls.onoffButton, this._classnames.onoffButtonDisabled);
                    this.fire(L.DistanceMeasurement.Events.Disabled);
                }
                return this;
            },

            /**
             * Re-enables the widget if was previously disabled.
             * @method enable
             * @chainable
             * @return {L.DistanceMeasurement}
             */
            enable: function() {
                if (this._disabled) {
                    this._disabled = false;
                    L.DomUtil.removeClass(this._controls.onoffButton, this._classnames.onoffButtonDisabled);
                    this.fire(L.DistanceMeasurement.Events.Enabled);
                }
                return this;
            }
        });

        return function(options) {
            var distanceMeasurement = new L.DistanceMeasurement(options);
            Utils.addDeprecatedProperty(distanceMeasurement, 'EVENTS', 'Events');
            return distanceMeasurement;
        };
    });



// WEBPACK FOOTER //
// ./widgets/controls/distanceMeasurement/distanceMeasurement.js